module.exports = __webpack_public_path__ + "static/media/clock.2621775e.png";